import VError from 'verror';
import type { VariantOf } from 'variant';
import type { CliErrorCode } from './cli-error-codes.js';

const { WError } = VError;

export type CliErrorCodeType = VariantOf<typeof CliErrorCode>;

function getNormalizedCause(cause: unknown) {
  if (cause == null) {
    return;
  }

  return cause instanceof Error ? cause : new Error(JSON.stringify(cause));
}

export class CliError extends WError {
  public cliCode: CliErrorCodeType;

  constructor(options: {
    code: CliErrorCodeType;
    cause: unknown;
    info?: Record<string, unknown>;
  }) {
    const normalizedCause = getNormalizedCause(options.cause);
    super(
      {
        name: options.code.type,
        cause: normalizedCause,
        info: options.info,
      },
      options.code.type
    );

    this.cliCode = options.code;
    this.name = options.code.type;
    if (process.env.NODE_ENV === 'development' && normalizedCause) {
      // If we get an unexpected error during tests, it helps to see the full
      // stack trace without debugging. This is especially useful when the error
      // is thrown in CI
      this.stack = `${this.stack}\ncaused by: ${VError.fullStack(normalizedCause)}`;
    }
  }
}
